<template>
    <div :class="'descritionpart p-0 ' + classRoot">
        <div class="description-collapse">
            <h3 class="mb-2">{{ title }}</h3>
            <p>{{ start }}<span id="product-description" v-show="more">{{ end }}</span></p>
            <button v-if="end" class="theme-btn btn-sm mt-3 btn-orange" type="button" @click="more = !more">
                {{ more ? "Read Less" : 'Read More' }}
            </button>
        </div>
        <hr style="height: 3px" class="my-3" v-if="hr" />
    </div>
</template>

<script>
export default {
    name: 'DetailDescription',
    props: {
        title: { default: 'Description'},
        start: { required: true },
        end: { required: true },
        classRoot: { default: '' },
        hr: {default: true}
    },
    data() {
        return {
            more: false,
        }
    }
}
</script>
